var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mx-auto",attrs:{"id":"main-app"},on:{"dragover":function($event){$event.preventDefault();}}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }